import React from "react";
import { Hammer } from "lucide-react";
import Layout from "@/components/Layout";
import { Button } from "@/ui";
import { useNavigate } from "react-router-dom";

export default function Placeholder({ title }) {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="placeholder">
        <div className="ph-icon"><Hammer size={20} strokeWidth={1.75} /></div>
        <h1 className="t-h1" style={{ marginBottom: 8 }}>{title}</h1>
        <p className="muted" style={{ marginBottom: 20 }}>
          we're building this next. it isn't ready yet — for now you can take orders, see stock and check today.
        </p>
        <Button variant="primary" onClick={() => navigate("/today")}>go to today</Button>
      </div>
    </Layout>
  );
}
